module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/257-sardinia-92aed957adfbeddc75c7da72de4aedf1.svg";